"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CrudService_1 = __importDefault(require("../../Core/CrudService"));
var VehicleEntity_1 = require("../Entity/VehicleEntity");
var Vehicle_consts_1 = require("../Vehicle.consts");
var VehiclesService = /** @class */ (function () {
    function VehiclesService(session) {
        this.service = new CrudService_1.default(session, 'vehicles');
    }
    VehiclesService.prototype.load = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.get(id)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.vehicle];
                }
            });
        });
    };
    VehiclesService.prototype.loadAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.getAll()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.vehicles];
                }
            });
        });
    };
    VehiclesService.prototype.create = function (vehicleData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(vehicleData)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.vehicle];
                }
            });
        });
    };
    VehiclesService.prototype.update = function (id, vehicleData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(id, vehicleData)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.vehicle];
                }
            });
        });
    };
    VehiclesService.prototype.batchUpdate = function (vehicles) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .patch(VehicleEntity_1.Routes.BATCH_UPDATE)
                            .withPayload({ vehicles: vehicles })
                            .setException('failed to batch update vehicles')
                            .withExtractor(Vehicle_consts_1.vehiclesExtractor)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    VehiclesService.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.delete(id)];
            });
        });
    };
    VehiclesService.prototype.loadAllByTeam = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(VehicleEntity_1.Routes.GET_BY_TEAM)
                            .withExtractor(Vehicle_consts_1.vehiclesExtractor)
                            .setException("failed to load vehicles from team ".concat(teamId))
                            .withRouteParams({ teamId: teamId })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    VehiclesService.prototype.getCsvUploadFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(VehicleEntity_1.Routes.GET_CSV_UPLOAD_FIELDS)
                        .withExtractor(Vehicle_consts_1.getCsvFieldsExtractor)
                        .setException('failed to get vehicles csv upload fields')
                        .invoke()];
            });
        });
    };
    VehiclesService.prototype.importVehiclesCsv = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = new FormData();
                formData.append('file', file);
                return [2 /*return*/, this.service.routeGenerator
                        .post(VehicleEntity_1.Routes.IMPORT_VEHICLES_CSV)
                        .withHeaders({ 'Content-Type': 'multipart/form-data' })
                        .setException('failed to import vehicles csv')
                        .withPayload(formData)
                        .invoke()];
            });
        });
    };
    VehiclesService.prototype.getAssignmentHistory = function (vehicle_id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = this.service.routeGenerator
                    .post(VehicleEntity_1.Routes.GET_ASSIGNMENT_HISTORY)
                    .withExtractor(Vehicle_consts_1.assignmentHistoryExtractor)
                    .setException("failed to get vehicle_Id: ".concat(vehicle_id, " assignment history"))
                    .withPayload({ vehicle_id: vehicle_id });
                if (options) {
                    request.withQueryString(options);
                }
                return [2 /*return*/, request.invoke()];
            });
        });
    };
    /**
     * @deprecated The method should not be used. Backend is not merged.
     */
    VehiclesService.prototype.loadPagedVehicles = function (cursor, filters, limit, page_action) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(VehicleEntity_1.Routes.PAGED_VEHICLES)
                            .withQueryString(__assign(__assign({}, filters), { cursor: cursor, limit: limit, page_action: page_action }))
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return VehiclesService;
}());
exports.default = VehiclesService;
//# sourceMappingURL=vehicles-service.js.map